import React from 'react';
import { AddInternalOrderContactForm } from './AddInternalContactForm';
import { UUID } from '../../../../types/shared/UUID';

interface AddInternalContactContainerProps {
  showAddContactForm: boolean;
  cancelAddContact: () => void;
  onSelectExistingAdminContact: (adminId: UUID) => void;
}

export const AddInternalContactContainer: React.FC<AddInternalContactContainerProps> = ({
  cancelAddContact,
  showAddContactForm,
  onSelectExistingAdminContact,
}) => {
  if (!showAddContactForm) {
    return null;
  }

  return <AddInternalOrderContactForm onSelectAdmin={onSelectExistingAdminContact} onCancel={cancelAddContact} />;
};
